module.exports = __webpack_public_path__ + "static/media/001.9036c453.jpg";